(function($) {

  window.onload  = function (e) {
    let animated_objects = $('body .animate');

    // console.log(animated_objects[0]);

    animated_objects.addClass('load')
  }
}(jQuery));
